<div class="sidenav_container"  [@onSideNavChangeRight]="sideNavStateRight ? 'close' : 'close'">
  <div fxLayout="column" fxLayoutGap="10px" style="height: 100%;">
      <router-outlet name="second"></router-outlet>
  </div>
</div>
